import React, { useState } from "react";
import logo from "../../assets/cargotool.png";
import "../../css/LoginRecovery.css";
import { Link } from "react-router-dom";
import Button from "../../components/input/Button";

const ResetPasswordForm = ({ onResetPassword }) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password === confirmPassword) {
      onResetPassword(password);
    } else {
      alert("Passwords do not match. Please try again."); // Replace with proper error handling
    }
  };

  return (
    <div>
      <form className="otp-form" onSubmit={handleSubmit}>
        <img
          src={logo}
          style={{
            width: "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto",
          }}
          alt="logo"
        />
        <h1 className="title">Password Recovery</h1>
        <p>Enter Your New Password.</p>

        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="New Password"
        />

        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Retype Password"
        />
        <Button type="submit" label="Reset Password" />
      </form>
      <Link to={"/login"} className="back-btn">
        Back to Login
      </Link>
    </div>
  );
};

export default ResetPasswordForm;
